<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fornecedores"
      class="elevation-0 mt-5"
      :loading="loading"
      hide-default-footer
      :server-items-length="fornecedores.length"
      no-data-text="Nenhum fornecedor encontrado"
      loading-text="Carregando fornecedores..."
    >
      <template v-slot:item.nome="{ item }">
        {{ item.fornecedor.pessoa.nome }}
        <px-open-pagina-fornecedor :id="item.id" :is-icon="false"/>
      </template>
      <template v-slot:item.cnpj="{ item }">
        {{ item.fornecedor.pessoa.cnpj | cnpj }}
      </template>
      <template v-slot:item.situcacao="{ item }">
        <px-ativo :ativo="!item.fornecedor.disabled"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon @click="remove(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    fornecedores: Array,
    default: [],
  },
  data() {
    return {
      headers: [
        {
          text: 'Nome',
          value: 'nome',
          sortable: false,
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
          sortable: false,
        },
        {
          text: 'Situação',
          value: 'situcacao',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    remove(item) {
      this.$emit('remove', item);
    },
  },
};
</script>
